import { z } from "zod";

export const rawDealProductSchema = z.object({
    id: z.coerce.string(),
    productId: z.coerce.string(),
    installLocationId: z.coerce.string().nullish(),
    quantity: z.number(),
    features: z.string().nullish(),
    previewImage: z.object({ url: z.string() }).nullish(),
});
